module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elRulesCopy_664043.c330d881.jpg";